import React, { useState, useEffect, useMemo } from 'react';
import {
  Box, Heading, VStack, Text, Spinner, Container,
  Table, Thead, Tbody, Tr, Th, Td, TableContainer,
  // --- ADD THESE IMPORTS ---
  Input, InputGroup, InputLeftElement,
} from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons'; // Import search icon
import axios from 'axios';

const API_BASE_URL = 'https://api-amg2dwk5ga-uc.a.run.app';

const PublicMemberList = () => {
  const [members, setMembers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  // --- ADDED: State to hold the search term ---
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const fetchMembers = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(`${API_BASE_URL}/api/public/members`);
        setMembers(response.data);
      } catch (error) {
        console.error('Error fetching public members:', error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchMembers();
  }, []);

  // --- ADDED: Filtering logic using useMemo for efficiency ---
  const filteredMembers = useMemo(() => {
    // If no search term, return all members
    if (!searchTerm) {
      return members;
    }
    // Otherwise, filter members by name
    return members.filter(member =>
      member.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [members, searchTerm]); // Recalculates only when members or searchTerm change

  if (isLoading) {
    return <VStack justify="center" align="center" h="50vh"><Spinner size="xl" /></VStack>;
  }

  return (
    <Container maxW="container.lg" py={12}>
      <Heading as="h1" size="xl" mb={4} textAlign="center">
        Community Members Directory
      </Heading>
      
      {/* --- ADDED: Search input field --- */}
      <InputGroup mb={8} size="lg">
        <InputLeftElement pointerEvents="none">
          <SearchIcon color="gray.300" />
        </InputLeftElement>
        <Input
          placeholder="Search by name..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          variant="filled"
        />
      </InputGroup>

      {/* --- MODIFIED: Check filteredMembers length instead of members --- */}
      {members.length > 0 && filteredMembers.length === 0 ? (
        <Text textAlign="center" fontSize="lg" color="gray.500">
            No members found matching your search.
        </Text>
      ) : (
        <TableContainer borderWidth="1px" borderRadius="lg">
          <Table variant="striped">
            <Thead bg="gray.100">
              <Tr>
                <Th isNumeric>Sr. No.</Th>
                <Th>Name</Th>
                <Th>Gotra</Th>
                <Th>Occupation</Th>
                <Th>Location</Th>
              </Tr>
            </Thead>
            <Tbody>
              {/* --- MODIFIED: Map over filteredMembers --- */}
              {filteredMembers.map((member, index) => (
                <Tr key={member.id}>
                  <Td isNumeric>{index + 1}</Td>
                  <Td fontWeight="medium">{member.name}</Td>
                  <Td>{member.gotra || 'N/A'}</Td>
                  <Td>{member.occupation || 'N/A'}</Td>
                  <Td>{member.location || 'N/A'}</Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      )}
    </Container>
  );
};

export default PublicMemberList;